import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import DSFRListContext from "components/DSFRListContext";
import Link from "components/templatesComponents/Link";
import Pictogram from "components/templatesComponents/Pictogram";
import { useGetAllSites } from "hooks/site.hook";
import PropTypes from "prop-types";
import React, { useContext, useMemo } from "react";
import getPictogramContents from "utils/pictogramUtils";

const DSFRTile = (props) => {
  const {
    link = {},
    title = "",
    description = "",
    icon = "",
    pictogram: pictogramProp = {},
    isHorizontal = false,
    fullWidth = false,
    titleSize = "md",
  } = props;
  let { pictogram = "", folder = "" } = pictogramProp;
  const { page: pageVersion = {}, url, external, title: titleLink } = link || {};
  const { fullPath, page = {} } = pageVersion;
  const { siteId } = page;

  const { xs, sm, lg } = useContext(DSFRListContext);

  const { data: allSites = [] } = useGetAllSites();

  const findSiteById = useMemo(() => allSites?.find((site) => site.id === siteId), [allSites, siteId]);

  const { host, name: siteNameById } = findSiteById || {};

  const logoSite = icon || siteNameById;

  if (icon && !folder && !pictogram) {
    const { folderOverride, pictogramOverride } = getPictogramContents(logoSite);
    folder = folderOverride;
    pictogram = pictogramOverride;
  }

  const isBoFullPath = useMemo(
    () => fullPath && fullPath.includes("site=") && fullPath.includes("page=") && fullPath.includes("version="),
    [fullPath],
  );

  let tileClassName = "fr-tile fr-enlarge-link";
  if (titleSize === "sm") {
    tileClassName += " fr-tile--sm";
  }
  if (isHorizontal) {
    tileClassName += " fr-tile--horizontal";
  }

  const linkUrl = useMemo(() => {
    if (url) {
      return url;
    }
    if (!isBoFullPath && host) {
      return `${host}${fullPath}`;
    }
    return fullPath;
  }, [url, isBoFullPath, host, fullPath]);

  return (
    <Grid size={{ xs, sm: fullWidth ? 12 : sm, lg: fullWidth ? 12 : lg }} component="li">
      <Box
        className={tileClassName}
        sx={{
          height: "100%",
          "& .fr-tile__title": {
            mb: isHorizontal ? 1 : 0,
            "& a:after": isHorizontal ? {} : { content: "none" },
          },
          "& .fr-tile__content": isHorizontal ? {} : { pb: "0px !important" },
        }}
      >
        <div className="fr-tile__body">
          <div className="fr-tile__content">
            <h6 className="fr-tile__title">
              <Link basic button url={linkUrl} title={titleLink} external={external} sx={{ wordBreak: "break-word" }}>
                {title}
              </Link>
            </h6>
            {isHorizontal && description && <p className="fr-tile__desc">{description}</p>}
          </div>
        </div>
        {folder && pictogram && !isHorizontal && (
          <div className="fr-tile__img">
            <Pictogram folder={folder} pictogram={pictogram} />
          </div>
        )}
      </Box>
    </Grid>
  );
};

DSFRTile.propTypes = {
  link: PropTypes.shape(),
  title: PropTypes.string,
  description: PropTypes.string,
  icon: PropTypes.string,
  pictogram: PropTypes.shape({
    pictogram: PropTypes.string,
    folder: PropTypes.string,
  }),
  isHorizontal: PropTypes.bool,
  fullWidth: PropTypes.bool,
  titleSize: PropTypes.string,
};

export default DSFRTile;
